// api/Aula/AcademicPerformancesService.ts
import client from "../Client/HttpClient";
import { IAcademicPerformancesModel } from "@/interfaces/modules";

const ApiPath = "AcademicPerformances";

export default {
  GetAcademicPerformances: (): Promise<IAcademicPerformancesModel[]> =>
    client.get(`${ApiPath}`),

    GetAcademicPerformancesByCompetencyId: (competencyId): Promise<IAcademicPerformancesModel[]> =>
    client.get(`${ApiPath}/byCompetency/${competencyId}`),

  GetAcademicPerformancesById: (data: IAcademicPerformancesModel): Promise<IAcademicPerformancesModel> =>
    client.get(`${ApiPath}/${data.Id}`),

  PostAcademicPerformances: (data: IAcademicPerformancesModel): Promise<IAcademicPerformancesModel> =>
    client.post(`${ApiPath}`, data),
};
